export default "__VITE_ASSET__DGLg76FJ__"